export default __webpack_public_path__ + "static/summer-sale-2025-subbanner-desktop-e7ea14ce9bc28aa88d02a1265f1efdc0.webp";